import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import TopBar from '../ProjectComponents/TopBar'
import LoginBody from './Components/LoginBody'
import IndexFooter from '../Index/Components/IndexFooter'
import SEOHelmet from '../ProjectComponents/SEOHelmet';

function LoginPage() {
  const navigate = useNavigate();
  const page = 'login';
  useEffect(() => {
    const loggedIn = localStorage.getItem('loggedIn') === 'true'; // Ensure you're checking the correct value as stored in localStorage
    if (loggedIn) {
      navigate('/backpack'); // Adjust the path as necessary for your homepage
    }
  }, [navigate]); // Dependency array ensures this effect only runs once on component mount
  return (
    <>
        {/* topbar */}
        <SEOHelmet page={page} />
        <div className='loginSignup main'>
          {/* <TopBar/> */}
          <LoginBody/>
        </div>

        {/* footer */}
        <IndexFooter/>

    </>
  )
}

export default LoginPage